import { useState } from "react";
import api from "../services/api";

const AddProductPopup = ({ initialName, onClose, onAdded }) => {
  const [form, setForm] = useState({
    name: initialName || "",
    barcode: "",
    price: "",
    gst_percent: "",
    opening_stock: ""
  });

  const saveProduct = async () => {
    if (!form.name || !form.price) {
      return alert("Product name and price required");
    }

    try {
      const payload = {
    ...form,
    price: Number(form.price),
    gst_percent: Number(form.gst_percent) || 0,
    inventory: Number(form.inventory) || 0
  };
      const res = await api.post("/products", payload);

      onAdded(res.data);
    } catch {
      alert("Failed to add product");
    }
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <h3 style={{ marginBottom: 10 }}>Add Product</h3>

        <input
          placeholder="Product Name"
          value={form.name}
          autoFocus
          onChange={e =>
            setForm({ ...form, name: e.target.value })
          }
          style={input}
        />

        <input
          placeholder="Barcode (optional)"
          value={form.barcode}
          onChange={e =>
            setForm({ ...form, barcode: e.target.value })
          }
          style={{ ...input, marginTop: 10 }}
        />

        <input
          type="number"
          placeholder="Price"
          value={form.price}
          onChange={e =>
            setForm({ ...form, price: e.target.value })
          }
          style={{ ...input, marginTop: 10 }}
        />

        <input
          type="number"
          placeholder="GST %"
          value={form.gst_percent}
          onChange={e =>
            setForm({
              ...form,
              gst_percent: e.target.value
            })
          }
          style={{ ...input, marginTop: 10 }}
        />

        <input
  type="number"
  placeholder="Opening Stock"
  value={form.opening_stock}
  onChange={e =>
    setForm({
      ...form,
      opening_stock: Number(e.target.value)
    })
  }
  style={{ ...input, marginTop: 10 }}
/>


        {/* ACTIONS */}
        <div style={actions}>
          <button style={btnCancel} onClick={onClose}>
            Cancel
          </button>
          <button style={btnConfirm} onClick={saveProduct}>
            Save & Add
          </button>
        </div>
      </div>
    </div>
  );
};

/* ================= SHARED STYLES (SAME AS CustomerPopup) ================= */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999
};

const modal = {
  background: "#ffffff",
  padding: 20,
  width: 380,
  borderRadius: 8,
  boxShadow: "0 10px 30px rgba(0,0,0,0.25)"
};

const input = {
  width: "100%",
  padding: "10px 12px",
  fontSize: 14,
  borderRadius: 6,
  border: "1px solid #cbd5e1",
  outline: "none",
  boxSizing: "border-box"
};

const actions = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  marginTop: 15
};

const btnCancel = {
  padding: "8px 14px",
  border: "1px solid #cbd5e1",
  background: "#f8fafc",
  cursor: "pointer",
  borderRadius: 6
};

const btnConfirm = {
  padding: "8px 14px",
  border: "none",
  background: "#2563eb",
  color: "#fff",
  cursor: "pointer",
  borderRadius: 6
};

export default AddProductPopup;
